import { EmojisActivities, EmojisAnimalsAndNature, EmojisCountryFlags, EmojisFoodAndDrink, EmojisObjects, EmojisSmileysAndPeople, EmojisSymbols, EmojisTravelAndPlaces } from "../newComponents2/EmojisUnicode";


const EmojiPicker = ({addEmojiToText}) => {
    return ( 
        <div className="emojipicker" style={{width:"100%",height:"100%",display:"grid",placeItems:"center",backgroundColor:"#282828",gap:"15px"}}>
            <br/>
              <h5>smileys and people</h5>
            <div className="smileysandpeople flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisSmileysAndPeople && EmojisSmileysAndPeople.map((data,index)=>(

                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                </div>

              ))}
            </div> <br/>
  
            <h5>symbols</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisSymbols && EmojisSymbols.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>
  
            <h5>Food and Drink</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisFoodAndDrink && EmojisFoodAndDrink.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>

            <h5>Animals and Nature</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisAnimalsAndNature && EmojisAnimalsAndNature.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>

            <h5>Activities</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisActivities && EmojisActivities.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>

            <h5>Travel and places</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisTravelAndPlaces && EmojisTravelAndPlaces.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>

            <h5>objects</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisObjects && EmojisObjects.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>

            <h5>Flags</h5>
            <div className="symbols flex-row2" style={{flexWrap:"wrap",gap:"10px"}}>
              {EmojisCountryFlags && EmojisCountryFlags.map((data,index)=>(
                  <div key={index} onClick={()=>addEmojiToText(data.emoji)} style={{cursor:"pointer", backgroundColor:"white"}}>
                    <h3>{data.emoji}</h3>
                  </div>
              ))}
            </div> <br/>
        </div>
     );
}
export default EmojiPicker;